<form [formGroup]="editBusinessProfileForm"
      (ngSubmit)="submitEditBusinessProfileForm()"
      class="grid xs-pr-32 xs-pl-32 xs-pt-32">
  <div class="grid__m-12">
    <div class="wrapper-custom-radiobutton">
      <label>
        <input type="radio" formControlName="active" [ngClass]="isBusinessProfileFormDisabled ? 'not-allowed' : ''"
               [value]="true">
        <div class="custom-radiobutton">
          <div class="circle-radio">
            <div class="circle-center"></div>
          </div>
          <span>Aktivan</span>
        </div>
      </label>
      <label>
        <input type="radio" formControlName="active" [ngClass]="isBusinessProfileFormDisabled ? 'not-allowed' : ''" [value]="false">
        <div class="custom-radiobutton">
          <div class="circle-radio">
            <div class="circle-center"></div>
          </div>
          <span>Neaktivan</span>
        </div>
      </label>
    </div>
  </div>
  <div class="grid__m-6">
    <div class="wrapper-input">
      <span class="label-input">Naziv firme</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.name | formControl"
               [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" [placeholder]="'Naziv firme'">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.name | formControlErrorMessages: null : formTriedToSubmit }}</span>
    </div>
    <gr-dropdown-reactive-form
      [items]="listOfCategories"
      [propIdentifier]="'id'"
      [dropdownLabel]="'Kategorije'"
      [disableSelect]="isBusinessProfileFormDisabled || isDisabledBusinessCategory"
      [ngClass]="{'not-allowed': isBusinessProfileFormDisabled || isDisabledBusinessCategory}"
      [placeholder]="'Izaberi kategoriju'"
      [formControl]="editBusinessProfileForm.controls.business_category_id | formControl"
      [formTriedToSubmit]="formTriedToSubmit"
    ></gr-dropdown-reactive-form>
    <div class="wrapper-input">
      <span class="label-input">Adresa firme</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.address | formControl"
               [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" [placeholder]="'Adresa firme'">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.address | formControlErrorMessages: null : formTriedToSubmit }}</span>
    </div>
    <gr-dropdown-reactive-form
      [items]="listOfCities"
      [propIdentifier]="'id'"
      [disableSelect]="isBusinessProfileFormDisabled"
      [dropdownLabel]="'Grad firme'"
      [placeholder]="'Grad firme'"
      [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}"
      [formControl]="editBusinessProfileForm.controls.business_location_id | formControl"
      [formTriedToSubmit]="formTriedToSubmit"
    ></gr-dropdown-reactive-form>
    <gr-dropdown-reactive-form
      [items]="listOfMunicipalities"
      [propIdentifier]="'id'"
      [disableSelect]="isBusinessProfileFormDisabled"
      [dropdownLabel]="'Opština firme'"
      [placeholder]="'Opština firme'"
      [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}"
      [formControl]="editBusinessProfileForm.controls.municipality_id | formControl"
      [formTriedToSubmit]="formTriedToSubmit"
    ></gr-dropdown-reactive-form>
    <gr-dropdown-reactive-form
      *ngIf="editBusinessProfileForm.controls?.business_category_id?.value && editBusinessProfileForm.controls?.business_category_id?.value !== 1"
      [items]="listOfMunicipalities"
      [isMultiSelect]="true"
      [propIdentifier]="'id'"
      [disableSelect]="isBusinessProfileFormDisabled"
      [dropdownLabel]="'Opštine obavljanja delatnosti'"
      [placeholder]="'Opštine obavljanja delatnosti'"
      [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}"
      [formControl]="editBusinessProfileForm.controls.workingMunicipalities | formControl"
      [formTriedToSubmit]="formTriedToSubmit"
    ></gr-dropdown-reactive-form>
    <div
      *ngIf="editBusinessProfileForm.controls.business_category_id.value === 6 ||editBusinessProfileForm.controls.business_category_id.value === 3"
      class="grid__m-6">
      <div class="wrapper-input">
        <span
          class="label-input">{{ editBusinessProfileForm.controls.business_category_id.value === 6 ? 'Maximalan broj torti u jednom danu' : 'Maximalan broj paketa u jednom danu' }}</span>
        <div class="zc-input">
          <input type="text" [formControl]="editBusinessProfileForm.controls.max_order_quantity | formControl"
                 [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}"
                 [placeholder]="editBusinessProfileForm.controls.business_category_id.value === 6 ? 'Maximalan broj torti u jednom danu' : 'Maximalan broj paketa u jednom danu'">
        </div>
        <span
          class="error-message">{{ editBusinessProfileForm.controls.max_order_quantity | formControlErrorMessages: 'Unesite validan broj.' : formTriedToSubmit }}</span>
      </div>
    </div>
    <div class="wrapper-input">
      <span class="label-input">Fiksni telefon firme</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.phone_number | formControl"
               [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" [placeholder]="'Fiksni telefon firme'">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.phone_number | formControlErrorMessages: 'Unesite validan broj telefona.' : formTriedToSubmit }}</span>
    </div>
    <div class="wrapper-input">
      <span class="label-input">Mobilni telefon firme</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.mobile_number | formControl"
               [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" [placeholder]="'Mobilni telefon firme'">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.mobile_number | formControlErrorMessages: 'Unesite validan broj telefona.' : formTriedToSubmit }}</span>
    </div>
    <div class="wrapper-input">
      <span class="label-input">Matični broj</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.identification_number | formControl"
               [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" [placeholder]="'Matični broj'">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.identification_number | formControlErrorMessages: 'Unesite validan matični broj.' : formTriedToSubmit }}</span>
    </div>
    <div class="wrapper-input">
      <span class="label-input">PIB</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.tax_identification_number | formControl"
               [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" [placeholder]="'PIB'">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.tax_identification_number | formControlErrorMessages: 'Unesite validan PIB broj.' : formTriedToSubmit }}</span>
    </div>
    <div class="wrapper-input">
      <span class="label-input">Račun firme</span>
      <div class="zc-input">
        <input
          type="text"
          mask="000-0000000000000-00"
          [formControl]="editBusinessProfileForm.controls.bank_account_number | formControl"
          [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}"
          [placeholder]="'Račun firme'">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.bank_account_number | formControlErrorMessages: 'Unesite validan broj računa firme.' : formTriedToSubmit }}</span>
    </div>
    <div class="wrapper-checkbox-custom">
      <div>
        <input class="checkbox-custom" [disabled]="isBusinessProfileFormDisabled" type="checkbox"
               id="highlightedBusiness"
               [formControl]="editBusinessProfileForm.controls.highlighted | formControl"
               [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}">
        <label class="checkbox-custom-label" for="highlightedBusiness">Istaknut</label>
      </div>
    </div>
    <div class="wrapper-promotion">
      <span class="title-promotion">Promocija</span>
      <span class="desc-promotion">Pre nego što stavite da je aktivna, morate selektovati do kod datuma će važiti promocija.</span>
      <div *ngIf="businessProfileData?.promotion_active">
        <span class="desc-promotion">informacija o starom rabatu, ako je promo aktivan
        stari rabat: {{businessProfileData?.promotion_previous_rebate}}</span>
      </div>
      <!--   TODO JS - Srediti da bude ovakav dizajn a ne ovo dole, meni nesto nece da radi   -->
      <div class="wrapper-checkbox-custom">
        <div>
          <input [checked]="isChecked" class="checkbox-custom" type="checkbox"
                 id="idk" (change)="onCheckboxChange($event)">
          <label class="checkbox-custom-label" for="highlightedBusiness">Aktiviraj</label>
        </div>
      </div>
      <div>
        Aktiviraj
        <input [checked]="isChecked" class="checkbox-custom" type="checkbox"
               id="idk2" (change)="onCheckboxChange($event)">
      </div>
      <div>
        <span class="desc-promotion">Izaberite datum do kad traje promocija</span>
        <mat-card class="demo-inline-calendar-card">
          <mat-calendar #calendar [selected]="selectedDate" (selectedChange)="onCalendarDateChange($event)"></mat-calendar>
        </mat-card>
      </div>
      <div *ngIf="showError">
        <span class="error-message">Datum je obavezan kada je checkbox čekiran</span>
      </div>
      <div>
        <button (click)="savePromotion()" type="button" class="zc-btn zc-btn--primary">
          <span>Sačuvajte promene</span>
        </button>
      </div>
    </div>
  </div>
  <div class="grid__m-6">
    <div class="wrapper-input">
      <span class="label-input">Početak radnog vremena</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.time_start | formControl" placeholder="08:00"
               mask="00:00" [dropSpecialCharacters]="false" [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.time_start | formControlErrorMessages: null : formTriedToSubmit }}</span>
    </div>
    <div class="wrapper-input">
      <span class="label-input">Kraj radnog vremena</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.time_end | formControl" placeholder="08:00"
               mask="00:00" [dropSpecialCharacters]="false" [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.time_end | formControlErrorMessages: null : formTriedToSubmit }}</span>
    </div>


    <div class="wrapper-input">
      <span class="label-input">Početak radnog vremena vikendom</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.weekend_time_start | formControl" placeholder="08:00"
               mask="00:00" [dropSpecialCharacters]="false" [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.weekend_time_start | formControlErrorMessages: null : formTriedToSubmit }}</span>
    </div>
    <div class="wrapper-input">
      <span class="label-input">Kraj radnog vremena vikendom</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.weekend_time_end | formControl" placeholder="08:00"
               mask="00:00" [dropSpecialCharacters]="false" [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.weekend_time_end | formControlErrorMessages: null : formTriedToSubmit }}</span>
    </div>


    <div *ngIf="editBusinessProfileForm.controls.business_category_id.value === 1" class="wrapper-input">
      <span class="label-input">Minimalni uzrast</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.age_range_from | formControl"
               [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" [placeholder]="'Primer: 3-10'">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.age_range_from | formControlErrorMessages: 'Unesite validan format.' : formTriedToSubmit }}</span>
    </div>
    <div *ngIf="editBusinessProfileForm.controls.business_category_id.value === 1" class="wrapper-input">
      <span class="label-input">Maximalni uzrast</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.age_range_to | formControl"
               [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" [placeholder]="'Primer: 3-10'">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.age_range_to | formControlErrorMessages: 'Unesite validan format.' : formTriedToSubmit }}</span>
    </div>
    <div *ngIf="editBusinessProfileForm.controls.business_category_id.value === 1" class="wrapper-input">
      <span class="label-input">Kapacitet dece</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.children_capacity | formControl"
               [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" [placeholder]="'Primer: 30'">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.children_capacity | formControlErrorMessages: 'Unesite validan broj.' : formTriedToSubmit }}</span>
    </div>
    <div *ngIf="editBusinessProfileForm.controls.business_category_id.value === 1" class="wrapper-input">
      <span class="label-input">Kapacitet odraslih</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.adult_capacity | formControl"
               [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" [placeholder]="'Primer: 10'">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.adult_capacity | formControlErrorMessages: 'Unesite validan broj.' : formTriedToSubmit }}</span>
    </div>
    <div class="wrapper-input">
      <span class="label-input">Geografska širina</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.latitude | formControl"
               [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" [placeholder]="'Primer: 43.23233'">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.latitude | formControlErrorMessages: 'Unesite validan broj.' : formTriedToSubmit }}</span>
    </div>
    <div class="wrapper-input">
      <span class="label-input">Geografska dužina</span>
      <div class="zc-input">
        <input type="text" [formControl]="editBusinessProfileForm.controls.longitude | formControl"
               [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" [placeholder]="'Primer: 43.23233'">
      </div>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.longitude | formControlErrorMessages: 'Unesite validan broj.' : formTriedToSubmit }}</span>
    </div>
    <gr-dropdown-reactive-form
      [items]="listOfPictograms"
      [isMultiSelect]="true"
      [propIdentifier]="'id'"
      [disableSelect]="isBusinessProfileFormDisabled"
      [dropdownLabel]="'Karakteristike (piktogrami)'"
      [placeholder]="'Odaberi'"
      [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}"
      [formControl]="editBusinessProfileForm.controls.pictograms_ids | formControl"
      [formTriedToSubmit]="formTriedToSubmit"
    ></gr-dropdown-reactive-form>
    <div class="grid__m-6">
      <div class="wrapper-input">
        <span *ngIf="isBusinessProfileFormDisabled"></span>
        <span class="label-input">Rabat</span>
        <div class="zc-input">
          <input type="text" formControlName="rebate" mask="separator.2"  [disabled]="businessProfileData?.promotion_active"  [readonly]="businessProfileData?.promotion_active" (blur)="formatOnBlur()"
                 [dropSpecialCharacters]="false" [allowNegativeNumbers]="false"
                 [ngClass]="{'not-allowed': isBusinessProfileFormDisabled || businessProfileData?.promotion_active}" [placeholder]="'Rabat npr: 10.00'">
        </div>
        <span
          class="error-message">{{ editBusinessProfileForm.controls.rebate | formControlErrorMessages: null : formTriedToSubmit }}</span>
      </div>
    </div>
    <div *ngIf="editBusinessProfileForm.controls.business_category_id.value === 1" class="grid__m-6">
      <div class="wrapper-input">
        <span class="label-input">Kapara za zakup termina</span>
        <div class="zc-input">
          <input type="text" formControlName="down_payment" [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}"
                 [placeholder]="'Kapara npr: 1000'">
        </div>
        <span
          class="error-message">{{ editBusinessProfileForm.controls.down_payment | formControlErrorMessages: null : formTriedToSubmit }}</span>
      </div>
    </div>
    <div
      *ngIf="editBusinessProfileForm.controls.business_category_id.value === 3 || editBusinessProfileForm.controls.business_category_id.value === 6"
      class="grid__m-6">
      <div class="wrapper-input">
        <span class="label-input">Cena dostave</span>
        <div class="zc-input">
          <input type="text" formControlName="delivery_price" [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}"
                 [placeholder]="'Cena dostave npr: 1000'">
        </div>
        <span
          class="error-message">{{ editBusinessProfileForm.controls.delivery_price | formControlErrorMessages: null : formTriedToSubmit }}</span>
      </div>
    </div>
    <div class="grid__m-6">
      <div class="wrapper-input">
        <span class="label-input">Napomena</span>
        <div class="zc-textarea">
          <textarea type="text" formControlName="note" [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}"></textarea>
        </div>
<!--        <span class="error-message">Error message</span>-->
      </div>
    </div>
  </div>
  <div class="grid__m-12">
    <div class="wrapper-promocode">
      <div class="title-promocode">Promo kodovi</div>
      <div class="content-promocode" formArrayName="promo_codes">
        <div *ngFor="let code of  promoCodes.controls; let i = index" [formGroupName]="i" class="promocode-wrapper">
          <div class="promocode">
            <div class="wrapper-checkbox-custom">
              <div class="wrapper-input">
                <span class="label-input">Aktivan</span>
                <div>
                  <input class="checkbox-custom"
                         type="checkbox"
                         formControlName="status"
                         [id]="'status'+i">
                  <label class="checkbox-custom-label" [for]="'status'+i"></label>
                </div>
              </div>
            </div>
            <div class="wrapper-input">
              <span class="label-input">Promo kod</span>
              <div class="zc-input">
                <input type="text" formControlName="code">
              </div>
              <div class="error" *ngIf="code.get('code')?.invalid && code.get('code')?.touched">
                <span class="error-message" *ngIf="code.get('code')?.errors?.['required']">Kod je obavezan.</span>
                <span class="error-message" *ngIf="code.get('code')?.errors?.['minlength']">Kod mora imati bar 4 karaktera.</span>
              </div>
            </div>
            <div class="wrapper-input percentage">
              <span class="label-input">Popust u %</span>
              <div class="zc-input">
                <input type="number" formControlName="discount">
              </div>
              <div class="error" *ngIf="code.get('discount')?.invalid && code.get('discount')?.touched">
                <span class="error-message" *ngIf="code.get('discount')?.errors?.['required']">Popust je obavezan.</span>
                <span class="error-message" *ngIf="code.get('discount')?.errors?.['min']">Popust mora biti bar 1%.</span>
                <span class="error-message" *ngIf="code.get('discount')?.errors?.['max']">Popust ne može biti veći od 100%.</span>
              </div>
            </div>
          </div>
          <div *ngIf="!isBusinessProfileFormDisabled" class="delete-promocode">
            <button (click)="removePromoCode(i)" type="submit" class="zc-btn zc-btn--white">
              <i class="fa-regular fa-trash-can"></i>
            </button>
          </div>
        </div>
        <div [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" class="wrapper-add-promocode">
          <button (click)="addPromoCode()" type="button" class="zc-btn zc-btn--primary">
            <span>Dodajte novi</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="grid__m-12">
    <div class="wrapper-custom-gallery">
      <div class="header-custom-gallery">
        <span class="title-gallery">Galerija</span>
        <div class="wrapper-btn-gallery">
          <div class="file-input">
            <input
              #fileInput
              type="file"
              accept=".jpg,.jpeg,.png,.svg"
              name="file-input"
              id="file-input"
              [disabled]="isBusinessProfileFormDisabled"
              class="file-input__input"
              multiple
              (change)="onFileChange($event)"
            />
            <label [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" class="file-input__label"
                   for="file-input"><span>Dodaj galeriju</span></label>
          </div>
          <button (click)="removeAllImages()" [disabled]="isBusinessProfileFormDisabled"
                  [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" class="zc-btn zc-btn--delete"
                  type="button"><span>Obriši sve slike</span></button>
        </div>
      </div>
      <div class="content-custom-gallery">
        <div class="wrapper-gallery-images">
          <div *ngFor="let imgUrl of imageUrls" class="wrapper-gallery-image">
            <img [src]="imgUrl.fullPath" alt="">
            <span [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" class="icon-delete"
                  (click)="removeSingleImage(imgUrl)">
                    <i class="fa-regular fa-trash-can"></i>
                  </span>
          </div>
        </div>
      </div>
      <span class="error-message">{{ editBusinessProfileForm.controls.images | formControlErrorMessages: null : formTriedToSubmit }}</span>
    </div>
  </div>
  <!--  TODO ZOCA 360 images -->
  <div class="grid__m-12">
    <div class="wrapper-custom-gallery">
      <div class="header-custom-gallery">
        <span class="title-gallery">Galerija 360</span>
        <div class="wrapper-btn-gallery">
          <div class="file-input">
            <input
              type="file"
              accept=".jpg,.jpeg,.png"
              multiple
              id="file-input-360"
              [disabled]="isBusinessProfileFormDisabled"
              (change)="on360FileChange($event)"
            />
            <label [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" class="file-input__label"
                   for="file-input-360"><span>Dodaj 360</span></label>
          </div>
          <button (click)="removeAll360Images()" [disabled]="isBusinessProfileFormDisabled"
                  [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" class="zc-btn zc-btn--delete"
                  type="button"><span>Obriši sve 360 slike</span></button>
        </div>
      </div>
      <div class="content-custom-gallery">
        <div *ngIf="image360Urls.length" class="wrapper-gallery-images">
          <div *ngFor="let img of image360Urls" class="wrapper-gallery-image">
            <img [src]="img.fullPath" alt="">
            <span [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" class="icon-delete"
                  (click)="removeSingle360Image(img)">
                    <i class="fa-regular fa-trash-can"></i>
                  </span>
          </div>
        </div>
      </div>
      <span class="error-message">{{ editBusinessProfileForm.controls.images_360 | formControlErrorMessages: null : formTriedToSubmit }}</span>
    </div>
  </div>
  <!--  TODO ZOCA videos -->
  <div class="grid__m-12">
    <div class="wrapper-custom-gallery">
      <div class="header-custom-gallery">
        <span class="title-gallery">Galerija videa</span>
        <div class="wrapper-btn-gallery">
          <div class="file-input">
            <input
              type="file"
              multiple
              id="file-input-video"
              accept="video/*"
              [disabled]="isBusinessProfileFormDisabled"
              (change)="onVideoSelected($event)"
            />
            <label [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" class="file-input__label"
                   for="file-input-video"><span>Dodaj video</span></label>
          </div>
          <button (click)="removeAllVideos()" [disabled]="isBusinessProfileFormDisabled"
                  [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" class="zc-btn zc-btn--delete"
                  type="button"><span>Obriši sve videe</span></button>
        </div>
      </div>
      <div class="content-custom-gallery">
        <div *ngIf="videosUrls.length" class="wrapper-gallery-images">
          <div *ngFor="let video of videosUrls" class="wrapper-gallery-image">
            <video
              [src]="video?.fullPath"
              [poster]="video?.poster ? video?.poster : ''"
              controls
              preload="metadata"
              width="250"
              height="250"
            ></video>
            <span [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}" class="icon-delete"
                  (click)="removeSingleVideo(video)">
                    <i class="fa-regular fa-trash-can"></i>
                  </span>
          </div>
        </div>
      </div>
      <span class="error-message">{{ editBusinessProfileForm.controls.images_360 | formControlErrorMessages: null : formTriedToSubmit }}</span>
    </div>
  </div>
<!--  <div class="grid__m-12">-->
<!--    <div class="wrapper-quill-editor xs-mr-0 xs-ml-0 xs-mt-0">-->
<!--      <span class="title-editor">Dodaj video</span>-->
<!--      <input-->
<!--        type="file"-->
<!--        accept="video/*"-->
<!--        [disabled]="isBusinessProfileFormDisabled"-->
<!--        (change)="onVideoSelected($event)"-->
<!--      />-->
<!--    </div>-->
<!--    <div>-->
<!--      <video-->
<!--        *ngIf="businessProfileData?.video"-->
<!--        [src]="businessProfileData?.video?.full_path"-->
<!--        [poster]="businessProfileData?.video?.poster ? businessProfileData?.video?.poster : ''"-->
<!--        controls-->
<!--        preload="metadata"-->
<!--        width="250"-->
<!--        height="250"-->
<!--      ></video>-->
<!--    </div>-->
<!--  </div>-->
  <div class="grid__m-12">
    <div class="wrapper-quill-editor xs-mr-0 xs-ml-0 xs-mt-0">
      <span class="title-editor">Opis</span>
      <quill-editor
        [placeholder]="'Unesite opis...'"
        [ngClass]="{'not-allowed': isBusinessProfileFormDisabled}"
        [formControl]="editBusinessProfileForm.controls.description | formControl"></quill-editor>
      <span
        class="error-message">{{ editBusinessProfileForm.controls.description | formControlErrorMessages: null : formTriedToSubmit }}</span>
    </div>
  </div>
  <div class="grid__m-12">
    <div class="wrapper-save-btn fixed-btn">
      <button *ngIf="isBusinessProfileFormDisabled"
              (click)="enableBusinessProfileForm()"
              class="zc-btn zc-btn--primary" type="button">
        <i class="fa-solid fa-pen-to-square"></i>
      </button>
      <button *ngIf="!isBusinessProfileFormDisabled" class="zc-btn zc-btn--primary zc-position-relative" [disabled]="isLoaderActive" type="submit">
        <gr-loader *ngIf="isLoaderActive" [isButtonLoader]="true"></gr-loader>
        <i class="fa-solid fa-floppy-disk"></i>
      </button>
    </div>
  </div>
</form>
